// extracted by mini-css-extract-plugin
export default {"cont":"SingleUser_cont__Fg9sn"};